import { useEffect, useState } from "react";
import { api, EVENT_TYPES } from "./api";

let cache = null;

/** Categorie visibili al pubblico (Impostazioni → Categorie). */
export const useVisibleCategories = () => {
  const [cats, setCats] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/public/services").then(({ data }) => {
      cache = data.map((s) => {
        const t = EVENT_TYPES.find((x) => x.value === s.event_type);
        return { value: s.event_type, label: t?.label || s.title, plural: s.title || t?.plural || s.event_type };
      });
      setCats(cache);
    }).catch(() => setCats([]));
  }, []);
  return cats || [];
};
